import { defineMessages } from 'react-intl';

export default defineMessages({
  submit: {
    id: 'sentinel.components.searchForm.submit',
    description: 'The form submit button text',
    defaultMessage: 'Search',
  },
  transferId: {
    id: 'sentinel.components.searchForm.transferId',
    defaultMessage: 'Transfer Id',
  },
  startDate: {
    id: 'sentinel.components.searchForm.startDate',
    defaultMessage: 'Start Date',
  },
  endDate: {
    id: 'sentinel.components.searchForm.endDate',
    defaultMessage: 'End Date',
  },
  state: {
    id: 'sentinel.components.searchForm.state',
    defaultMessage: 'State',
  },
  direction: {
    id: 'sentinel.components.searchForm.direction',
    defaultMessage: 'Direction',
  },
  reviewRole: {
    id: 'sentinel.components.searchForm.reviewRole',
    defaultMessage: 'Review Role',
  },
  correspondentCode: {
    id: 'sentinel.components.searchForm.correspondentCode',
    defaultMessage: 'Correspondent Code',
  },
  clearingAccount: {
    id: 'sentinel.components.searchForm.clearingAccount',
    defaultMessage: 'Account',
  },
  programName: {
    id: 'sentinel.components.searchForm.programName',
    defaultMessage: 'Program Name',
  },
  transferType: {
    id: 'sentinel.components.searchForm.transferType',
    defaultMessage: 'Transfer Type',
  },
  fedRefNum: {
    id: 'sentinel.components.searchForm.fedRefNum',
    defaultMessage: 'Fed Ref #',
  },
  houseBankAccountNumber: {
    id: 'sentinel.components.searchForm.houseBankAccountNumber',
    defaultMessage: 'House Bank Acct.',
  },
});



// WEBPACK FOOTER //
// ./src/components/SearchForm/messages.js